import { ChangeDetectorRef, Component } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { AuthService, CmsBannerComponent, CmsService, OccConfig } from '@spartacus/core';
import { Observable } from 'rxjs';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ContentService } from '../../spartacus/services/content.service';

@Component({
    selector: 'app-jobbagcode-uk',
    templateUrl: './jobbagcode-uk.component.html',
    styleUrls: ['./jobbagcode-uk.component.scss'],
    standalone: false
})
export class JobbagcodeUkComponent {
  paracontent:string="";
  currentPage: string | undefined;
  isUserLoggedIn: boolean=false;
  componentData: any;

  constructor(public component: CmsComponentData<any>,protected authService:AuthService,protected contentService:ContentService,private cdr:ChangeDetectorRef,private sanitizer:DomSanitizer,protected config: OccConfig,private cmsService:CmsService) {  
    this.cmsService.getCurrentPage().subscribe((page)=>{
      this.currentPage = page?.pageId;
    })
  }

  ngOnInit(){

    this.authService.isUserLoggedIn().subscribe(res=>{
      this.isUserLoggedIn=res;
      this.cdr.detectChanges();
    });
    
    this.component.data$.subscribe((data) =>{
      this.componentData = data;
      this.paracontent = data?.jobBagCode;

    })
  }
}
